import { type DeepPartial } from '@direct-frontend/stdlib';
import { formatDiscountValue, getDiscountValueText } from '#shared/lib/discount';
import { PROMOACTIONS_MODE } from './constants';
import { type PromoactionModel } from './types';

export const getPromoactionValueText = (
    promoaction: DeepPartial<PromoactionModel>,
    isShort: boolean = false
): string => {
    if (promoaction.mode?.mode === PROMOACTIONS_MODE.automatic && promoaction.applicability?.type === 'PRODUCT_LIST') {
        return 'Разные скидки на товары';
    }

    const discount_type = promoaction.discount?.type;
    const discount_value = promoaction.discount?.value_percent || promoaction.discount?.value_fixed;

    if (promoaction.meta?.type === 'ladder') {
        return '';
    }

    if (promoaction.kind === 'PRICE_INDEX_AUTO') {
        const base = 'Минимальная цена на площадке';
        const formattedDiscountValue = formatDiscountValue(discount_type, discount_value);
        const effectDirection = promoaction.discount?.effect_direction;

        if (!effectDirection || effectDirection === 'ALIGN') {
            return base;
        }

        const sign = effectDirection === 'ADD' ? '+' : '-';

        return `${base} ${sign}${formattedDiscountValue}`;
    }

    return getDiscountValueText({
        discountType: discount_type,
        discountValue: discount_value,
        minimumOrderAmount: promoaction.discount?.minimum_order_amount,
        isShort,
    });
};
